// extracted by mini-css-extract-plugin
export var modal = "_uk-0";
export var table = "_uk-1";